import React from 'react'
import { Link } from 'gatsby'

import Title from '../components/common/title'
import Apply from '../components/forms/apply'
import PageLayout from '../components/pagelayout'
import SEO from '../components/seo'

const ApplyPage = () => (
  <PageLayout>
    <SEO title="Apply" />
    <Title value="Apply" classes="dark-blue" />
    <div className="body margin-bottom-large">
      Thank you for your interest in becoming a Reading Mentor! Our application
      process is simple—here’s how it works:
    </div>
    <ol>
      <li>
        Complete the application and code of conduct on this page. Our Volunteer
        Coordinator will forward this information to the appropriate school
        district.
      </li>
      <li>
        Watch for an email from our Volunteer Coordinator with information on
        completing the required background check.
      </li>
      <li>
        Complete your background check, and email our Volunteer Coordinator.
      </li>
    </ol>
    <div className="body bold margin-bottom-large">
      All fields are required unless otherwise noted.
    </div>
    <Apply />
    <Link to="/">Go back to the homepage</Link>
  </PageLayout>
)

export default ApplyPage
